import { render } from "./AppStep.vue?vue&type=template&id=08050a9b&scoped=true"
import script from "./AppStep.vue?vue&type=script&lang=js"
export * from "./AppStep.vue?vue&type=script&lang=js"

import "./AppStep.vue?vue&type=style&index=0&id=08050a9b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08050a9b"]])

export default __exports__